"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderSpecialtiesListItem = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const dot_spacer_styles_1 = require("../../lib/styles/dot-spacer.styles");
exports.ProviderSpecialtiesListItem = styled_1.default.h2 `
  list-style: none;
  margin: 0 ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_small')} 0;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  display: inline-block;

  & + h2:before {
    ${(props) => (0, dot_spacer_styles_1.dotSpacer)({ marginRight: (0, ui_theme_1.fromTheme)('spacing_small')(props) })}
  }
`;
//# sourceMappingURL=provider-specialties.styles.js.map